var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bindEmailShow
    ? _c("div", { staticClass: "popup", staticStyle: { zIndex: "200" } }, [
        _c("div", { staticClass: "content", attrs: { id: "bindPass" } }, [
          _c(
            "div",
            {
              staticClass: "title",
              staticStyle: { "border-radius": "9px 9px 0 0" }
            },
            [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("language.popup.personalCenter.bindEmail")) +
                  "\r\n            "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.closePage()
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "personInfo-content",
              staticStyle: { "flex-direction": "column" }
            },
            [
              _vm.touristPurchase
                ? _c("div", { staticClass: "before-subscribe" }, [
                    _c("span", { staticClass: "icon-notice" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.paySystem.beforeBind")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "inline-flex" } }, [
                _c("div", { staticClass: "personInfo-column" }, [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("language.common.emailAccount")))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.common.newPassword")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "personInfo-column personInfo-column-msg" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      domProps: { value: _vm.email },
                      on: {
                        blur: function($event) {
                          return _vm.testEmail()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "password-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.passWord,
                            expression: "passWord"
                          }
                        ],
                        ref: "passWord",
                        attrs: { type: "password", maxlength: "16" },
                        domProps: { value: _vm.passWord },
                        on: {
                          blur: function($event) {
                            return _vm.passwordVerification()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.passWord = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "password-eye",
                        class: _vm.showPassword ? "icon-eye" : "icon-eye-hide",
                        on: {
                          click: function($event) {
                            return _vm.checkShowPassword()
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                !_vm.touristPurchase
                  ? _c(
                      "button",
                      {
                        staticClass: "personInfo-button",
                        class:
                          _vm.passWord && _vm.email ? "" : "button-noclick",
                        on: {
                          click: function($event) {
                            return _vm.updateUserInfo()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.save")))]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "personInfo-button",
                        class:
                          _vm.passWord && _vm.email ? "" : "button-noclick",
                        on: {
                          click: function($event) {
                            return _vm.updateUserInfo()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.popup.reportPopup.next"))
                        )
                      ]
                    )
              ])
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-693c3a41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693c3a41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/bind_email_popup.vue
// module id = null
// module chunks = 